import { Socket } from "../assets/js/phoenix"

const getSocketUrl = (app) => {
  let ws_protocol = 'wss'
  let base_url = app.getBaseUrl()
  let splited_url = base_url.split(':')
  let protocol = splited_url.shift()
  if (protocol === 'http') {
    ws_protocol = 'ws'
  }
  return ws_protocol + ':' + splited_url.join(':') + '/socket'
}

const init = (app) => {
  app.store.socket = null
  app.store.connectSocket = (token, {timeout,  successCallback, errorCallback}) => {
    const heartbeatIntervalMs = timeout ? timeout+500 : null;
    app.store.socket = new Socket(getSocketUrl(app), {params: {token}, timeout, heartbeatIntervalMs})
    if(typeof successCallback == "function") app.store.socket.onOpen(successCallback)
    if(typeof errorCallback == "function") app.store.socket.onError(errorCallback)
    app.store.socket.connect()
  }

  app.store.disconnectSocket = () => {
    app.store.socket.disconnect(() => console.info("Disconnected"))
  }

  app.store.connectToChannel = (channel_name, events, params) => {
    let channel = app.store.socket.channel(channel_name, {params})

    channel.join()
      .receive("ok", _response => console.info("Catching up on channel for " + channel_name))
      .receive("error", reason => console.info("Failed join", reason))
      .receive("timeout", () => console.warn("Networking issue... Still waiting..."))

    events.forEach(event => {
      channel.on(event.name, event.action(app))
    });

    channel.onClose(e => console.log("Channel closed", e))
  }

  app.store.disconnectFromChannel = (channel_name) => {
    let channel = app.store.socket.channel(channel_name, {})
    channel.leave()
  }
}

export default {
  init
}



// WEBPACK FOOTER //
// ./src/stores/Sockets.js